export function Footer() {
  return (
    <footer className="text-muted-foreground mt-10 p-4 text-center">
      DIGICAP &copy; rifaqui.com.br - {new Date().getFullYear()}
    </footer>
  )
}
